<script>
    export let demo, col, filter, start, end, rows, neighborhoods, gasconLabel, hochmanLabel, nbhAdjust;
    let container;
    import { sizeScale } from '../utils/size.js';
    import { formatStr, formatIncome } from '../utils/format.js';
    import { colorScale } from '../utils/color.js';
    let data = demo;
    let margin = {top:0, right:25, bottom:0, left:25};
    let axis = [0,25,50,75,100];
    // Filter to the candidates we want to focus on
    $: candidateFilter = data.filter((d) => rows.includes(d.winner));
    // Filter to the demographics we want to focus on
    // Plot them separately on top and push the other down down in comparison
    $: demographicFilter = candidateFilter.filter((d) => d[filter] == "True");
    $: neighborhoodFilter = candidateFilter.filter((d) => neighborhoods.includes(d.neighborhood));
    $: gasconLabelVal = gasconLabel;
    $: hochmanLabelVal = hochmanLabel;
    $: nbhAdjustVal = nbhAdjust;

    let height = 600;
    let rowHeight = 300;
    let gHeight = height*0.15;
    let hHeight = height*0.85;

    $: console.log(nbhAdjustVal);

</script>

<div bind:this={container} class="temp-outer-container sticky" style="height:{height}px;">
    <svg 
        class="circle" 
        height={height} 
        style="width: calc(100% - {margin.left + margin.right}px);">
        <g transform="translate({margin.left}, {margin.top})">
            <line class="axis"
                x1="50%"
                x2="50%"
                y1="{margin.top}"
                y2="{100}%"
                stroke-width="1"
                stroke="#b7b7b7"
                stroke-dasharray="3"
            ></line>
            <text class="axis__text"
                x="50%"
                dx="-12px"
                y="{margin.top}"
                text-anchor="end"
                >&larr; More owners
            </text>
            <text class="axis__text"
                x="50%"
                dx="12px"
                y="{margin.top}"
                text-anchor="start"
                >More renters &rarr;
            </text>
            {#if gasconLabelVal == "true"}
            <text class="axis__text"
                x="9.6%"
                y="{gHeight+40}"
                >GASCÓN
            </text>
            {/if}
            {#if hochmanLabelVal == "true"}
            <text class="axis__text"
                x="3%"
                y="{hHeight+40}"
                >HOCHMAN
            </text>
            {/if}
            {#each candidateFilter as obj}
                <circle
                    class="temp-circle {formatStr(obj.neighborhood)}"
                    cx="{obj[col]*100}%" 
                    cy="{obj.winner == "George Gascón" ? gHeight : hHeight}px"
                    r="{sizeScale(obj.spread)/2}px"
                    fill="{colorScale(obj.winner)}"
                    stroke-width="1"
                    stroke="{colorScale(obj.winner)}"
                    fill-opacity="{filter == '' ? 0.25 : 0.05}"
                    stroke-opacity="{filter == '' ? 0.5 : 0.15}"
                >
                </circle>
            {/each}
            {#if demographicFilter.length > 0}
                {#each demographicFilter as obj}
                <circle
                    class="temp-circle {formatStr(obj.neighborhood)}"
                    cx="{obj[col]*100}%"
                    cy="{obj.winner == "George Gascón" ? gHeight : hHeight}px"
                    r="{sizeScale(obj.spread)/2}px"
                    fill="{colorScale(obj.winner)}"
                    stroke-width="1"
                    stroke="{colorScale(obj.winner)}"
                    fill-opacity="0.75"
                    stroke-opacity="1"
                >
                </circle>
                {/each}
            {/if}
            {#if neighborhoods.length > 0}
                {#each neighborhoodFilter as nbh}
                    <circle
                        class="temp-circle"
                        cx="{nbh[col]*100}%"
                        cy="{nbh.winner == "George Gascón" ? gHeight : hHeight}px"
                        r="{sizeScale(nbh.spread)/2}px"
                        fill="none"
                        stroke-width="1"
                        stroke="black"
                    >
                    </circle>
                    {#if nbhAdjustVal == nbh.neighborhood}
                    <text 
                        class="demo-axis-label {formatStr(nbh.neighborhood)}"
                        x="{(nbh[col]*100)}%"
                        y="{nbh.winner == "George Gascón" ? gHeight - (16 + sizeScale(nbh.spread)/2) : hHeight - (16 + sizeScale(nbh.spread)/2)}px"
                        text-anchor="middle"
                        >
                        {nbh.neighborhood}
                    </text>
                    {:else}
                    <text 
                        class="demo-axis-label {formatStr(nbh.neighborhood)}"
                        x="{(nbh[col]*100)}%"
                        y="{nbh.winner == "George Gascón" ? gHeight + (20 + sizeScale(nbh.spread)/2) : hHeight - (16 + sizeScale(nbh.spread)/2)}px"
                        text-anchor="middle"
                        >
                        {nbh.neighborhood}
                    </text>
                    {/if}
                {/each}
            {/if}
        </g>
    </svg>
</div>